import { get } from 'lodash';
import {
    NEW_SUBPATIENT_FORM_ROOT_KEY,
    BookingStateProperties,
} from '../../constants';
import patientSelector from '../../selectors/PatientSelector';
import bookingStateSelector from '../../selectors/BookingStateSelector';

const mapStateToProps = (state = {}) => {
    if (state[NEW_SUBPATIENT_FORM_ROOT_KEY] === undefined) {
        throw new Error(
            `Expected the select patient page state to be available as 'state.${NEW_SUBPATIENT_FORM_ROOT_KEY}'. ` +
                "Ensure you have added the `newSubpatientFormReducer` to your store's reducers via `combineReducers`."
        );
    }

    const bookingState = bookingStateSelector(state);

    return {
        bookingId: get(bookingState, BookingStateProperties.bookingId),
        patientId: patientSelector(state).patientId,
        ...state[NEW_SUBPATIENT_FORM_ROOT_KEY],
    };
};

export default mapStateToProps;
